import { Box, Button, HStack } from '@chakra-ui/react';
import { Trans, useTranslation } from 'react-i18next';
import { useAuth } from '~auth/useAuth';
import { WarningIcon } from '~components/ui/icons';
import { CONTAINER_MAX_WIDTH, CONTAINER_PADDING } from '~components/ui/PageContent';
import { getElevatedOrganizationId, goToOrganization } from '~utils/elevatedOrganization';

/**
 * Shown while a Service Admin is working in another organization under an access grant, so it is
 * always clear whose data is on screen and how to get back.
 */
export function ElevatedOrganizationBanner() {
  const { t } = useTranslation();
  const { organization } = useAuth();

  if (!getElevatedOrganizationId() || !organization) {
    return null;
  }

  return (
    <Box bgColor="orange.50" borderBottom="1px solid" borderColor="orange.100">
      <HStack
        maxW={CONTAINER_MAX_WIDTH}
        marginX="auto"
        paddingX={CONTAINER_PADDING}
        paddingY="2"
        spacing="3"
        fontSize="sm"
        color="orange.700"
      >
        <WarningIcon width="5" height="5" color="orange.400" />
        <Box flex="1">
          <Trans
            i18nKey="elevatedOrganizationBanner"
            values={{ name: organization.name }}
            components={{ strong: <strong /> }}
          />
        </Box>
        <Button
          size="sm"
          variant="link"
          colorScheme="orange"
          onClick={() => goToOrganization(null)}
        >
          {t('backToMyOrganization')}
        </Button>
      </HStack>
    </Box>
  );
}
